import React from 'react';

export default function useOutsideClickAlerter(ref: React.MutableRefObject<HTMLElement>, handler: () => void): void {
	React.useEffect(() => {
		const handleClickOutside = (event: MouseEvent): void => {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				handler?.call(this);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref]);
}
